<template>
  <div class="choice">
    <div v-if="data.questionType == 1" class="choiceItem">
      <div class="choiceTitle">
        【单选题】
        <span class="score">（本题{{ data.score }}分）</span>
      </div>
      <div class="testName">
        {{ num + 1 }}.
        <div class="name" v-html="data.questionName"></div>
      </div>
      <el-radio-group v-model="data.signListRadio" @change="changeSignList">
        <div v-for="choiceItem in data.optionList" :key="choiceItem.optionId">
          <el-radio :label="choiceItem.optionId">
            <div class="optionChoice">
              <div
                class="optionTag"
                :class="{
                  active: data.signListRadio == choiceItem.optionId,
                }"
              >
                {{ choiceItem.optionTag }}
              </div>
              <div class="optionName" v-html="choiceItem.optionName"></div>
            </div>
          </el-radio>
        </div>
      </el-radio-group>
    </div>

    <div v-if="data.questionType == 4" class="choiceItem">
      <div class="choiceTitle">
        【判断题】
        <span class="score">（本题{{ data.score }}分）</span>
      </div>
      <div class="testName">
        {{ num + 1 }}.
        <div class="name" v-html="data.questionName"></div>
      </div>
      <el-radio-group v-model="data.judgeListRadio" @change="changeSignList">
        <div v-for="choiceItem in data.optionList" :key="choiceItem.optionId">
          <el-radio :label="choiceItem.optionId">
            <div class="optionChoice">
              <div
                class="optionName_panduan"
                :class="{
                  active: data.judgeListRadio == choiceItem.optionId,
                }"
              >
                {{ choiceItem.optionName }}
              </div>
            </div>
          </el-radio>
        </div>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    allArr: {
      type: Array,
      default: () => [],
    },
    num: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {}
  },
  watch: {
    allArr() {
      // console.log(val);
    },
  },
  created() {},
  methods: {
    changeSignList(val) {
      console.log(val)
    },
  },
}
</script>

<style scoped lang="scss">
.choice {
  .active {
    background-color: #3671bf !important;
    color: #ffffff !important;
  }
  .wrap {
    display: flex;
  }
  .choiceItem {
    .choiceTitle {
      font-size: 16px;
      font-family: Source Han Sans CN-Bold, Source Han Sans CN;
      font-weight: bold;
      color: #3671bf;
      .score {
        color: #909399;
      }
    }

    .testName {
      display: flex;
      font-size: 18px;
      font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
      font-weight: normal;
      color: #333333;
      margin-top: 30px;
      .name {
        margin-left: 10px;
        width: 100%;
        height: auto;
      }
    }
  }
  ::v-deep .el-radio-group {
    .optionChoice {
      display: flex;
      align-items: center;
      width: 100%;
      .optionTag {
        width: 28px;
        line-height: 28px;
        background: #ffffff;
        border: 1px solid #d8dee6;
        text-align: center;
        border-radius: 50%;
        margin-right: 10px;
      }
      .optionName {
        width: calc(100% - 38px);
        height: auto;
        white-space: pre-wrap;
        line-height: 20px;
      }
      .optionName_panduan {
        width: 100px;
        line-height: 30px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #d8dee6;
        text-align: center;
        cursor: pointer;
        .el-button {
          width: 100px;
          height: 40px;
        }
      }
    }
    width: 100%;
    margin-top: 24px;
    .el-radio__input {
      display: none;
    }
    .el-radio__label {
      font-size: 14px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #545454;
      line-height: 14px;
    }
    .el-radio {
      width: 100%;
    }
  }
}
</style>
